import { createContext, useContext, useEffect, useState } from "react";
import Lenis from "lenis";

const LenisCtx = createContext(null);
export const useLenis = () => useContext(LenisCtx);

export const LenisProvider = ({ children }) => {
  const [lenis, setLenis] = useState(null);

  useEffect(() => {
    const l = new Lenis({ lerp: 0.085, smoothWheel: true, wheelMultiplier: 0.9 });
    let id;
    const raf = (t) => {
      l.raf(t);
      id = requestAnimationFrame(raf);
    };
    id = requestAnimationFrame(raf);
    setLenis(l);
    return () => {
      cancelAnimationFrame(id);
      l.destroy();
    };
  }, []);

  return <LenisCtx.Provider value={lenis}>{children}</LenisCtx.Provider>;
};

export const scrollToId = (lenis, id) => {
  const el = document.getElementById(id);
  if (!el) return;
  if (lenis) lenis.scrollTo(el, { offset: -72, duration: 1.5 });
  else el.scrollIntoView({ behavior: "smooth" });
};
